module.exports = __webpack_public_path__ + "img/LTE.9091319a.svg";